import React, { Component } from 'react';
import Helmet from 'react-helmet';

import OrderHistory from './OrderHistory';
import withAuth from './WithAuth';
import Layout from './Layout';

class OrdersPage extends Component {
  componentDidMount() {
    // Handle cart success redirect from PayPal
    var search = this.props.history.location.search || '';
    if (search.indexOf('cartSuccess=true') !== -1) {
      // Clear cart from localStorage and notify CartProvider
      localStorage.removeItem('primal_cart');
      localStorage.removeItem('primal_cart_pending_paypal');
      window.dispatchEvent(new Event('cartCleared'));
      // Redirect to confirmation page
      this.props.history.replace('/order-confirmation', {
        cartPurchase: true,
        paypal: true,
      });
    }
  }

  render() {
    return (
      <Layout>
        <Helmet>
          <title>Orders — Primal Marketplace</title>
        </Helmet>
        <div className="tw-max-w-3xl tw-mx-auto tw-px-4 tw-py-8">
          <h1 className="tw-text-xl tw-font-bold tw-text-[#111] dark:tw-text-white tw-mb-6">Orders</h1>
          <OrderHistory history={this.props.history} />
        </div>
      </Layout>
    );
  }
}

export default withAuth(OrdersPage);
